import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button, Col, Row, Space } from "antd";
import {
  AndroidFilled,
  AppleFilled,
  ArrowDownOutlined,
} from "@ant-design/icons";
import { HomeGamesData } from "../../helperFunction";
import "./styles.scss";

const HomeGames = ({ isDetail }) => {
  const navigate = useNavigate();
  const displayItems = isDetail ? HomeGamesData : HomeGamesData?.slice(0, 4);
  const handleNavigation = (gameId) => {
    navigate(`/game-detail/${gameId}`);
  };
  return (
    <section className={`home-games ${isDetail ? "games-detail" : ""}`}>
      <div className="section-title-text">
        {isDetail ? "Check our games" : "Our Games"}
      </div>
      <div className="section-title-desc">
        Haven't downloaded yet? What are you waiting for?
      </div>
      <Row
        gutter={isDetail ? [48, 48] : [24, 24]}
        className={`home-game-img-text ${
          isDetail ? "home-game-img-text-detail" : ""
        }`}
      >
        {displayItems?.map((e, index) => {
          return (
            <Col
              xs={24}
              sm={24}
              md={isDetail ? 8 : 6}
              lg={isDetail ? 8 : 6}
              xl={isDetail ? 8 : 6}
              xxl={isDetail ? 8 : 6}
              key={index}
            >
              <div
                className="img-text-container"
                onClick={() => handleNavigation(e?.id)}
              >
                <img
                  src={e?.gameImg}
                  alt="#"
                  className={`home-game-img ${
                    isDetail ? "home-game-img-detail" : ""
                  }`}
                />
                <div
                  className={`game-desc-text ${
                    isDetail ? "game-desc-text-detail" : ""
                  }`}
                >
                  {e?.gameDesc}
                </div>
              </div>
              {isDetail && (
                <Space direction="vertical" size={30}>
                  <div className="game-detail-text">{e?.detail}</div>
                  <Space direction="horizontal" align="center" size={10}>
                    <Link to={e?.appleLink}>
                      <AppleFilled />
                    </Link>
                    <Link to={e?.anroidLink}>
                      <AndroidFilled />
                    </Link>
                  </Space>
                  <Button
                    block
                    className="more-games-btn"
                    onClick={() => handleNavigation(e?.id)}
                  >
                    More
                  </Button>
                </Space>
              )}
            </Col>
          );
        })}
      </Row>
      {!isDetail && (
        <Button
          className="more-games-btn"
          icon={<ArrowDownOutlined />}
          iconPosition="end"
          href="/games"
        >
          More Games
        </Button>
      )}
    </section>
  );
};

export default HomeGames;
